<template>
  <div class="order-page">
    <div class="container page">
      <template v-if="!order.status.valify">
      <fieldset class="form-group">
        簡訊驗證:
        <input type="text" class="form-control" v-model="verifyCode" placeholder="請輸入驗證碼" />
        <input type="button" class="form-control" value="送出" @click="orderVerify(verifyCode)" />
      </fieldset>
      </template>
      <template v-else>
      <div>請向外送員示出QRcode取餐</div>
      <qrcode-vue :value="completeUrl+'/'+order.orderId" :size="300" level="H"></qrcode-vue>
      <div>單號: {{order.orderId}}</div>
      <div>金額: {{order.amount}}</div>
      <div>時間: {{order.date}}</div>
      <div>
        <div>
          狀態:
          <span>
            驗證
            <input
              class="align-middle"
              type="checkbox"
              :disabled="true"
              v-model="order.status.valify"
              :true-value="true"
              :false-value="false"
            />
          </span>
          <span>
            備餐
            <input
              class="align-middle"
              type="checkbox"
              :disabled="true"
              v-model="order.status.ready"
              :true-value="true"
              :false-value="false"
            />
          </span>
          <span>
            遞送
            <input
              :disabled="true"
              class="align-middle"
              type="checkbox"
              v-model="order.status.sending"
              :true-value="true"
              :false-value="false"
            />
          </span>
          <span>
            付款
            <input
              type="checkbox"
              disabled
              v-model="order.status.complete"
              :true-value="true"
              :false-value="false"
            />
          </span>
        </div>
      </div>
      <br>
      <div v-if="prompt">
        將網站加到主頁面以免弄丟訂單:
        <b-button block variant="secondary" @click="deferredPrompt">加到主頁面</b-button>
      </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import store from "@/store";
import QrcodeVue from "qrcode.vue";
export default {
  name: "Order",
  async beforeRouteEnter(to, from, next) {
    await store.dispatch("fetchOrder", to.params.slug);
    return next();
  },
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch("fetchOrder", to.params.slug);
    return next();
  },
  methods: {
    deferredPrompt() {
      if (window.deferredPrompt) {
        window.deferredPrompt.prompt();
        window.deferredPrompt.userChoice.then(choiceResult => {
          console.log(choiceResult.outcome);
          if (choiceResult.outcome === "dismissed") {
            console.log("dismissed");
          } else {
            console.log("accepted");
            this.$store.dispatch("promptToggle");
          }
        });
      }
    },
    async orderVerify(verifyCode) {
      this.$store.dispatch("orderVerify", verifyCode);
    }
  },
  data() {
    return {
      inProgress: false,
      verifyCode: "",
      errors: {}
    };
  },
  mounted() {},
  computed: {
    completeUrl() {
      return (
        window.location.origin +
        "/" +
        this.$router.resolve({ name: "order-complete" }).href
      );
    },
    order() {
      return this.$route.params.order;
    },
    ...mapGetters(["order", "prompt"])
  },
  components: {
    QrcodeVue
  }
};
</script>
